import { NativeSelect } from "@mantine/core";

import styles from "./DeviceSelector.module.css";

interface DeviceSelectorProps {
  devices: MediaDeviceInfo[];
  disabled?: boolean;
  selectedDeviceId: string | undefined;
  onSelect: (deviceId: string) => void;
}

export const DeviceSelector = ({
  devices,
  disabled = false,
  selectedDeviceId,
  onSelect,
}: DeviceSelectorProps) => {
  // Hide the selector when only one (or zero) devices are available — there's
  // nothing to pick between.
  if (devices.length <= 1) {
    return null;
  }

  const options = devices.map((device, index) => ({
    label: device.label || `Microphone ${index + 1}`,
    value: device.deviceId,
  }));

  return (
    <NativeSelect
      className={styles.selector}
      data={options}
      disabled={disabled}
      onChange={(event) => onSelect(event.currentTarget.value)}
      size="xs"
      value={selectedDeviceId ?? ""}
    />
  );
};
